import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from './ui/badge';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export const ShortPill = ({ short, onClick }) => {
  if (!short) return null;

  const content = (
    <motion.div
      initial={{ opacity: 0, x: -10 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.3 }}
      data-testid="short-pill"
      onClick={onClick}
      className="group relative flex items-start gap-3 p-4 rounded-lg border border-border bg-[hsl(var(--surface-2))] hover:bg-[hsl(var(--surface-3))] hover:border-primary/30 transition-all duration-200 cursor-pointer"
    >
      {/* Coral accent bar */}
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-primary rounded-l-lg opacity-60 group-hover:opacity-100 transition-opacity duration-200" />

      {/* Thumbnail if available */}
      {short.thumbnailUrl && (
        <div className="flex-shrink-0 w-16 h-16 rounded overflow-hidden">
          <img
            src={short.thumbnailUrl}
            alt=""
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      )}

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-2">
          <Badge className="text-xs uppercase tracking-wide bg-[hsl(var(--primary)/0.12)] text-[hsl(var(--primary))] border-0">
            {short.parentType}
          </Badge>
          {short.tags && short.tags.length > 0 && (
            <span className="text-xs text-muted-foreground">#{short.tags[0]}</span>
          )}
        </div>
        <p className="text-sm leading-relaxed text-foreground line-clamp-3 group-hover:text-primary/90 transition-colors duration-200">
          {short.summary}
        </p>
      </div>

      {/* Arrow icon */}
      <div className="flex-shrink-0 text-muted-foreground group-hover:text-primary transition-colors duration-200">
        <ArrowRight className="h-4 w-4" />
      </div>
    </motion.div>
  );

  // If we have an id, wrap in Link, otherwise just return the content
  if (short.id) {
    return <Link to={`/shorts/${short.id}`}>{content}</Link>;
  }

  return content;
};